import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ApiService } from '../../shared/ApiService/api.service';
import { Observable, of, BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class HomePageFeedsService {
  private wp_url = 'https://blog.apprenticeshipindia.gov.in/';

  constructor(
    private apiService: ApiService,
    private http: HttpClient,
  ) { }
  getAnnouncement(): Observable<any> {
    const url = `${this.wp_url}/wp-json/wp/v2/gallery/?per_page=100`;
    return this.apiService.get(url);
  }
  getNews(): Observable <any> {
    const url = `${this.wp_url}/wp-json/wp/v2/news/?per_page=100`;
    return this.apiService.get(url);
  }
  getNotices(): Observable<any> {
    const url = `${this.wp_url}/wp-json/wp/v2/notices/?per_page=100`;
    return this.apiService.get(url);
  }
  getCasting(): Observable<any> {
    const url = `${this.wp_url}/wp-json/wp/v2/casting/?per_page=100`;
    return this.apiService.get(url);
  }
  getTestimonial(): Observable<any> {
    const url = `${this.wp_url}/wp-json/wp/v2/testimonials/?per_page=100`;
    return this.apiService.get(url);
  }
  getTestStories(): Observable<any> {
    const url = `${this.wp_url}/wp-json/wp/v2/stories/?per_page=100`;
    return this.apiService.get(url);
  }
  getGalleryInfos(): Observable<any>{
    const url = `${this.wp_url}/wp-json/wp/v2/gallery/?per_page=100`;
    return this.apiService.get(url);
  }
  getPmnamNews(page_size: number = 10): Observable<any> {
    const url = `${environment.base_url}/apprenticeship-mela/get-news?page_size=${page_size}`;
    return this.apiService.get(url);
  }
}
